import React from 'react';
import { useLocation, useHistory } from 'react-router';
import { useOnMount } from '@chaser/components';
import LoadingMessage from '../../components/LoadingMessage';
import AuthenticationService from '../../services/authentication-service';
import usePush from '../../hooks/usePush';
import useUser from '../../hooks/useUser';
import { parseQueryString } from '../../util';
import { setShortCode } from '../../duck/actions/organisation';
import { useDispatch } from 'react-redux';

const LoginXero = () => {
  const dispatch = useDispatch();
  const user = useUser();
  const location = useLocation();
  const history = useHistory();
  const { execute } = usePush(AuthenticationService.loginXero);

  let { tenantId } = parseQueryString(location.search);
  if (tenantId) tenantId = decodeURIComponent(tenantId);

  function getIfUserIsLoggedIn(user, tenantId) {
    if (user.isLoggedIn && getUserOrgByTenantId(user, tenantId)) {
      return true;
    }

    return false;
  }

  function getUserOrgByTenantId(user, tenantId) {
    return user.organisations.find(org => org.OrganisationID === tenantId);
  }

  async function login() {
    const [err, res] = await execute();

    if (err) {
      history.push('/login', {
        loginError: 'Sorry. The system was not able to authenticate using Xero.',
      });
      return;
    }

    const { url } = res;
    window.location.replace(url);
  }

  useOnMount(() => {
    if (getIfUserIsLoggedIn(user, tenantId)) {
      dispatch(setShortCode(getUserOrgByTenantId(user, tenantId).ShortCode));
      history.replace('/');
    } else {
      login();
    }
  });

  return <LoadingMessage center useLogoAnimation />;
};

export default LoginXero;
